import { render, staticRenderFns } from "./dateBlocksVertical.vue?vue&type=template&id=2297e792&scoped=true"
import script from "./dateBlocksVertical.vue?vue&type=script&lang=js"
export * from "./dateBlocksVertical.vue?vue&type=script&lang=js"
import style0 from "./dateBlocksVertical.vue?vue&type=style&index=0&id=2297e792&prod&scoped=true&lang=css"
import style1 from "./dateBlocksVertical.vue?vue&type=style&index=1&id=2297e792&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2297e792",
  null
  
)

export default component.exports